import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../api/client';

interface JoinStep { id: string; title: string; subTitle: string; description: string; }

export default function JoinPage() {
  const { t, i18n } = useTranslation();
  const [steps, setSteps] = useState<JoinStep[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/join-section/get-all`).then(r => setSteps(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [i18n.language]);

  return (
    <div style={s.page}>
      <h1 style={s.pageTitle}>{t('join_title')}</h1>
      <p style={s.subtitle}>{t('join_subtitle')}</p>

      {loading ? (
        <div style={s.empty}>{t('join_loading')}</div>
      ) : steps.length === 0 ? (
        <div style={s.empty}>{t('join_empty')}</div>
      ) : (
        <div style={s.stepsWrap}>
          {steps.map((step, i) => (
            <div key={step.id} style={s.stepCard}>
              <div style={s.stepNumber}>{i + 1}</div>
              <div style={s.stepBody}>
                <div style={s.stepTitle}>{step.title}</div>
                {step.subTitle && <div style={s.stepSubTitle}>{step.subTitle}</div>}
                <div style={s.stepDesc}>{step.description}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={s.applyBox}>
        <h2 style={s.applyTitle}>{t('join_apply_title')}</h2>
        <p style={s.applyText}>{t('join_apply_text')}</p>
        <a href="/contacts" style={s.applyBtn}>{t('join_apply_btn')}</a>
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  page: { maxWidth: 860, margin: '0 auto', padding: '48px 40px' },
  pageTitle: { fontSize: '2rem', color: '#1a3a6b', marginBottom: 12 },
  subtitle: { color: '#555', fontSize: '1rem', marginBottom: 48, lineHeight: 1.6 },
  empty: { textAlign: 'center', padding: 60, color: '#888' },
  stepsWrap: { display: 'flex', flexDirection: 'column', gap: 20, marginBottom: 56 },
  stepCard: { display: 'flex', gap: 24, alignItems: 'flex-start', background: '#fff', borderRadius: 12, padding: '24px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', borderLeft: '4px solid #1a3a6b' },
  stepNumber: { minWidth: 44, height: 44, borderRadius: '50%', background: '#1a3a6b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', fontWeight: 700, flexShrink: 0 },
  stepBody: { flex: 1 },
  stepTitle: { fontSize: '1.05rem', fontWeight: 700, color: '#1a2a4a', marginBottom: 4 },
  stepSubTitle: { fontSize: '0.9rem', color: '#1a3a6b', fontWeight: 600, marginBottom: 8 },
  stepDesc: { fontSize: '0.92rem', color: '#555', lineHeight: 1.65 },
  applyBox: { background: '#1a3a6b', borderRadius: 14, padding: '36px 40px', textAlign: 'center' as const },
  applyTitle: { color: '#fff', fontSize: '1.5rem', marginBottom: 12 },
  applyText: { color: 'rgba(255,255,255,0.8)', fontSize: '0.97rem', marginBottom: 24 },
  applyBtn: { display: 'inline-block', padding: '13px 32px', background: '#fff', color: '#1a3a6b', borderRadius: 8, fontWeight: 700, fontSize: '1rem', textDecoration: 'none' },
};
